import './style/index.js';

import _Dropdown from './Dropdown';

export type { DropdownProps } from './Dropdown';
export * from './type';

export const Dropdown = _Dropdown;

export default Dropdown;
